// extracted by mini-css-extract-plugin
export default {"component":"TransferOrderList_component__ndi2A","container":"TransferOrderList_container__Ls2zT"};